import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@resy/ui-kitchen';
import { handleMktAnalytics } from '../../../AmexMarketingUtils/AmexUtils';
import {
  CTA_EVENT_NAME, AMEX_UTM_SOURCE, AMEX_DELTA_UTM_MEDIUM, AMEX_DELTA_UTM_BOOKING_CAMPAIGN,
} from '../../../AmexMarketingUtils/constants';
import './DeltaWifiFeaturedVenueCard.scss';

const DeltaWifiFeaturedVenueCard = ({
  restaurant, bookNowLinkText, analyticsEvent,
}) => {
  const cardContent = () => (
    <>
      <div
        className="DeltaWifiFeaturedVenueCard--image"
        style={{
          backgroundImage: `url(${restaurant.image})`,
        }}
      />
      <h3 className="DeltaWifiFeaturedVenueCard--name">{restaurant.name}</h3>
      <p className="DeltaWifiFeaturedVenueCard--features">
        {restaurant.cuisine}
        &nbsp;&middot;&nbsp;
        {restaurant.locationName}
        &nbsp;&middot;&nbsp;
        {restaurant.range}
      </p>
      {restaurant.bookNowLink && (
        <p className="DeltaWifiFeaturedVenueCard--booknowlink">
          {bookNowLinkText}
        </p>
      )}
    </>
  );

  const { bookNowLink = '' } = restaurant;
  if (bookNowLink) {
    const extraParams = {
      action_name: 'Featured Venue Card Click',
      ...(restaurant.name && { item_name: restaurant.name }),
    };

    const utm = {
      utm_source: AMEX_UTM_SOURCE,
      utm_medium: AMEX_DELTA_UTM_MEDIUM,
      utm_campaign: AMEX_DELTA_UTM_BOOKING_CAMPAIGN,
    };
    return (
      <div className="DeltaWifiFeaturedVenueCard">
        <Link
          target="_blank"
          rel="noopener noreferrer"
          href={{ pathname: bookNowLink, query: utm }}
          onClick={() => { handleMktAnalytics(analyticsEvent, CTA_EVENT_NAME, extraParams); }}
        >
          {cardContent()}
        </Link>
      </div>
    );
  }

  return (
    <div className="DeltaWifiFeaturedVenueCard">
      <div>
        {cardContent()}
      </div>
    </div>
  );
};

DeltaWifiFeaturedVenueCard.defaultProps = {
  restaurant: {},
  bookNowLinkText: '',
};

DeltaWifiFeaturedVenueCard.propTypes = {
  restaurant: PropTypes.shape({
    id: PropTypes.number,
    image: PropTypes.string,
    name: PropTypes.string,
    cuisine: PropTypes.string,
    city_name: PropTypes.string,
    bookNowLink: PropTypes.string,
    range: PropTypes.string,
    currency: PropTypes.string,
    locationName: PropTypes.string,
  }),
  bookNowLinkText: PropTypes.string,
  analyticsEvent: PropTypes.func.isRequired,
};

export default DeltaWifiFeaturedVenueCard;
